import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface KnowledgeUIState {
  searchQuery: string;
  uploadProgress: number | null;
}

const initialState: KnowledgeUIState = {
  searchQuery: '',
  uploadProgress: null,
};

const knowledgeSlice = createSlice({
  name: 'knowledgeUI',
  initialState,
  reducers: {
    setKnowledgeSearchQuery(state, action: PayloadAction<string>) {
      state.searchQuery = action.payload;
    },
    setUploadProgress(state, action: PayloadAction<number | null>) {
      state.uploadProgress = action.payload;
    },
  },
});

export const { setKnowledgeSearchQuery, setUploadProgress } = knowledgeSlice.actions;
export default knowledgeSlice.reducer;
